// ABOUTME: Skeleton loading card component for better perceived performance
// Shows loading placeholder while content is being fetched

import React from 'react';
import { cn } from '@/lib/utils';

interface SkeletonCardProps {
  className?: string;
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({ className }) => {
  return (
    <div
      className={cn(
        "p-4 border border-gray-200 rounded-xl bg-white animate-pulse animate-spring-in",
        className
      )}
    >
      {/* Header with icon and title */}
      <div className="flex items-start mb-3">
        <div className="h-10 w-10 bg-gray-200 rounded-full mr-3" />
        <div className="flex-1">
          <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
          <div className="h-4 bg-gray-100 rounded w-1/2" />
        </div>
      </div>

      {/* Content lines */}
      <div className="space-y-2 mt-4">
        <div className="h-3 bg-gray-100 rounded w-full" />
        <div className="h-3 bg-gray-100 rounded w-4/5" />
      </div>

      {/* Action buttons */}
      <div className="flex justify-between items-center mt-4">
        <div className="flex space-x-2">
          <div className="h-10 w-10 bg-gray-100 rounded-full" />
          <div className="h-10 w-10 bg-gray-100 rounded-full" />
        </div>
        <div className="h-10 w-10 bg-gray-100 rounded-full" />
      </div>
    </div>
  );
};
